module.exports = __webpack_public_path__ + "static/media/call_back_to_home.d3dbaf31.svg";